import React, { useEffect, useState } from 'react';
import { FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import StyledCommonLabel from '../../../../style/Common/Controller/Common/StyledCommonLabel';
import StyledCommonInputRequiredLabel from '../../../../style/Common/Controller/Common/StyledCommonInputRequiredLabel';
import StyledCommonInputWrapper from '../../../../style/Common/Controller/Common/StyledCommonInputWrapper';
import createDefaultInputRules from '../../../../util/Common/Controller/Generator/createDefaultInputRules';

const CommonMultipleInput = ({ ...props }) => {
  const {
    control,
    unregister,
    setValue,
    formState: { errors: formErrors },
  } = useFormContext();
  /**
   * @label {string} - Label of input
   * @maxLength {number} - Max length of input
   * @required {boolean} - Required input
   * @disabled {boolean} - Disable input
   * @defaultValue {string} - Default value of input
   * @width {string} - Width of input
   * @inputName {string} - Name of input
   */
  const [label, setLabel] = useState(props?.label);

  const [maxLength, setMaxLength] = useState(props?.maxLength || [20, 20, 20]);
  useEffect(() => {
    setMaxLength(props?.maxLength);
  }, [props?.maxLength]);

  const [required, setRequired] = useState(
    props?.required || [false, false, false],
  );
  useEffect(() => {
    setRequired(props?.required);
  }, [props?.required]);

  const [disabled, setDisabled] = useState(
    props?.disabled || [false, false, false],
  );
  useEffect(() => {
    setDisabled(props?.disabled);
  }, [props?.disabled]);

  const [defaultValue, setDefaultValue] = useState(
    props?.defaultValue || ['', '', ''],
  );
  useEffect(() => {
    setDefaultValue(props?.defaultValue);
  }, [props?.defaultValue]);

  const [inputName, setInputName] = useState(
    props?.inputName || ['multi_input_1', 'multi_input_2', 'multi_input_3'],
  );

  return (
    <div>
      <div>
        {(!!label || props.labelVisible !== false) && (
          <StyledCommonLabel
            labelStyle={props?.labelStyle}
            lbl-pd-right={props?.[`lbl-pd-right`]}
          >
            {!!label && (
              <>
                {!!required?.includes(true) && (
                  <StyledCommonInputRequiredLabel>
                    *
                  </StyledCommonInputRequiredLabel>
                )}
                {label}
              </>
            )}
          </StyledCommonLabel>
        )}
      </div>
      <div className={`${props?.width ? `${props?.width}` : 'w-full'} flex`}>
        <div>
          <Controller
            control={control}
            name={inputName?.[0]}
            defaultValue={defaultValue?.[0]}
            rules={createDefaultInputRules({
              ...props,
              validate: props?.validate?.[0],
            })}
            render={({
              field: { ref, onChange, value, ...field },
              fieldState: { invalid, error },
            }) => {
              // Package of handler props
              const handlerProps = {
                onChange,
                value,
                maxLength,
                ...field,
                ...props,
              };

              // Render Control Input Component
              return (
                <div>
                  <StyledCommonInputWrapper labelStyle={props?.labelStyle}>
                    <div>
                      <input
                        type="text"
                        ref={ref}
                        maxLength={maxLength?.[0]}
                        value={value}
                        disabled={disabled?.[0]}
                        onClick={e =>
                          props?.onClickHandler?.({ e, ...handlerProps })
                        }
                        onKeyDown={e =>
                          props?.onKeyDownHandler?.({ e, ...handlerProps })
                        }
                        onChange={e =>
                          props?.onChangeHandler
                            ? props?.onChangeHandler[0]({ e, ...handlerProps })
                            : null
                        }
                        placeholder={props?.placeholder?.[0] || ''}
                        className={`
                    ${
                      (formErrors?.[inputName?.[0]]?.message ||
                        formErrors?.[inputName?.[1]]?.message ||
                        formErrors?.[inputName?.[2]]?.message) &&
                      (required?.[0] || required?.[1] || required?.[2])
                        ? 'border-red-700'
                        : 'hover:border-[#8E9396]  focus:border-[1px] focus:border-[#264B9F] focus:shadow-[0_0_4px_rgba(139,188,233,1)]'
                    }
                  box-border
                  px-3 py-2 text-[12px] font-[500]
                  border-[#D9D9D9] border-[1px] w-full h-[30px]
                  rounded-l-[5px]  outline-none 
                 ${
                   disabled?.[0] || disabled?.[1] || disabled?.[2]
                     ? 'hover:border-[#D9D9D9] text-[#222]'
                     : ''
                 }
                  `}
                      />
                    </div>
                  </StyledCommonInputWrapper>
                </div>
              );
            }}
          />
        </div>
        <div>
          <Controller
            control={control}
            name={inputName?.[1]}
            defaultValue={defaultValue?.[1]}
            rules={createDefaultInputRules({
              ...props,
              validate: props?.validate?.[1],
            })}
            render={({
              field: { ref, onChange, value, ...field },
              fieldState: { invalid, error },
            }) => {
              // Package of handler props
              const handlerProps = {
                onChange,
                value,
                maxLength,
                ...field,
                ...props,
              };

              // Render Control Input Component
              return (
                <div>
                  <StyledCommonInputWrapper labelStyle={props?.labelStyle}>
                    <div>
                      <input
                        type="text"
                        ref={ref}
                        maxLength={maxLength?.[1]}
                        value={value}
                        disabled={disabled?.[1]}
                        onClick={e =>
                          props?.onClickHandler?.({ e, ...handlerProps })
                        }
                        onKeyDown={e =>
                          props?.onKeyDownHandler?.({ e, ...handlerProps })
                        }
                        onChange={e =>
                          props?.onChangeHandler
                            ? props?.onChangeHandler[1]({ e, ...handlerProps })
                            : null
                        }
                        placeholder={props?.placeholder?.[1] || ''}
                        className={`
                ${
                  (formErrors?.[inputName?.[0]]?.message ||
                    formErrors?.[inputName?.[1]]?.message ||
                    formErrors?.[inputName?.[2]]?.message) &&
                  (required?.[0] || required?.[1] || required?.[2])
                    ? 'border-red-700'
                    : ' hover:border-[#8E9396] hover:border-[1px] focus:border-[#264B9F] focus:shadow-[0_0_4px_rgba(139,188,233,1)]'
                }
                  box-border
                  text-[12px] font-[500]
                  px-3 py-2 border-[#D9D9D9] border-[1px] w-full h-[30px] border-x-transparent
                  outline-none
                       ${
                         disabled?.[0] || disabled?.[1] || disabled?.[2]
                           ? 'hover:border-[#D9D9D9] hover:border-x-transparent text-[#222]'
                           : ''
                       }
                  `}
                      />
                    </div>
                  </StyledCommonInputWrapper>
                </div>
              );
            }}
          />
        </div>
        <div>
          <Controller
            control={control}
            name={inputName?.[2]}
            defaultValue={defaultValue?.[2]}
            rules={createDefaultInputRules({
              ...props,
              validate: props?.validate?.[2],
            })}
            render={({
              field: { ref, onChange, value, ...field },
              fieldState: { invalid, error },
            }) => {
              // Package of handler props
              const handlerProps = {
                onChange,
                value,
                maxLength,
                ...field,
                ...props,
              };

              // Render Control Input Component
              return (
                <div>
                  <StyledCommonInputWrapper labelStyle={props?.labelStyle}>
                    <div>
                      <input
                        type="text"
                        ref={ref}
                        maxLength={maxLength?.[2]}
                        value={value}
                        disabled={disabled?.[2]}
                        onClick={e =>
                          props?.onClickHandler?.({ e, ...handlerProps })
                        }
                        onKeyDown={e =>
                          props?.onKeyDownHandler?.({ e, ...handlerProps })
                        }
                        onChange={e =>
                          props?.onChangeHandler
                            ? props?.onChangeHandler[2]({ e, ...handlerProps })
                            : null
                        }
                        placeholder={props?.placeholder?.[2] || ''}
                        className={`
                    ${
                      (formErrors?.[inputName?.[0]]?.message ||
                        formErrors?.[inputName?.[1]]?.message ||
                        formErrors?.[inputName?.[2]]?.message) &&
                      (required?.[0] || required?.[1] || required?.[2])
                        ? 'border-red-700'
                        : ' focus:border-[1px] focus:border-[#264B9F] focus:shadow-[0_0_4px_rgba(139,188,233,1)] hover:border-[#8E9396]'
                    }
                  box-border
                  px-3 py-2 text-[12px] font-[500]
                  border-[#D9D9D9] border-[1px] w-full h-[30px]
                  rounded-r-[5px] outline-none ${
                    disabled?.[0] || disabled?.[1] || disabled?.[2]
                      ? 'hover:border-[#D9D9D9] text-[#222]'
                      : ''
                  }
                  `}
                      />
                    </div>
                  </StyledCommonInputWrapper>
                </div>
              );
            }}
          />
        </div>
      </div>
      <div
        className={`${
          required?.[0] || required?.[1] || required?.[2]
            ? 'block'
            : 'invisible'
        }`}
      >
        <FormHelperText className="text-[#ff2424] text-[11px] font-normal min-h-[11px] h-[11px] mb-[3px] leading-none">
          {!props?.suppressErrorVisible &&
            (formErrors?.[inputName?.[0]]?.message ||
              formErrors?.[inputName?.[1]]?.message ||
              formErrors?.[inputName?.[2]]?.message)}
        </FormHelperText>
      </div>
    </div>
  );
};

export default CommonMultipleInput;
